module.exports = __webpack_public_path__ + "static/img/xx_04.ac11158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/images/xx_04.png
// module id = C9vs
// module chunks = 3